import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { IRequirementsNpaForm } from 'KnmPackage/RequirementsNpaModalModule/interfaces/IRequirementsNpaForm';

const emptyMessage = 'Поле не может быть пустым';
const required = makeRequired(emptyMessage);

export const NpaValidator = (values: IRequirementsNpaForm) => {
  return {
    number: required(values.number),
    title: required(values.title),
    dateAcceptance: required(values.dateAcceptance),
  };
};
